module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-black-89eebcc49141ea2d2e176cfa98bb5743.svg";